export const DISABLE_PASSWORD_MANAGERS_PROPS = Object.freeze({
  // Per https://support.logmeininc.com/lastpass/help/manage-your-form-fills-lp040002
  // and https://kylenunery.com/lastpass-autofill-rules/, adding this property to an input
  // ensures that LastPass will not add an autofill icon to it.
  'data-lpignore': 'true',
})
